// extracted by mini-css-extract-plugin
export default {"container":"vertical_container__uybc-","item":"vertical_item__ou3Pr"};